import { createApp } from "vue";
import App from "./App.vue";
import "./styles.css";

import { prefetchOrder } from "./services/orderApi";

prefetchOrder();

createApp(App).mount("#app");

if (import.meta.env.VITE_POSTHOG_ENABLED === "true") {
  import("./analytics/posthog").then((m) => m.initPostHog());
}
